export default "__VITE_ASSET__5cefef40__"